<template>
  <a-card :bordered="false">
    <a-form layout="inline">
      <a-form-item>
        <a-input v-model="queryParams.orderId" placeholder="项目ID"></a-input>
      </a-form-item>
      <a-form-item>
        <a-input v-model="queryParams.itemName" placeholder="项目名称"></a-input>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
      </a-form-item>
    </a-form>
    <custom-page-table
      style="margin-top:16px;"
      ref="table"
      :queryParams="queryParams"
      :columns="columns"
      base-key="resourceUrl"
      params-path="order/getPlatformOrderPage"
    >
      <span slot="action" slot-scope="rowItem">
        <a v-if="rowItem.record.orderStatus == 1" @click="orderModificationEvent(rowItem.record)">申请改单</a>
        <a v-if="rowItem.record.orderStatus == 1" style="margin-left: 20px"
           @click="refundEvent(rowItem.record)">申请退款</a>
      </span>
    </custom-page-table>
  </a-card>
</template>

<script>
export default {
  name: 'PushOrder',
  data() {
    return {
      queryParams: {},
      columns: [
        {
          title: '订单号',
          dataIndex: 'orderId'
        },
        {
          title: '商品名称',
          dataIndex: 'proName',
          width: '400px'
        },
        {
          title: '联系人',
          dataIndex: 'orderContact'
        },
        {
          title: '所属项目',
          dataIndex: 'itemName',
          width: '200px'
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId
    }
  },
  created() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'ResourceControlList', title: '项目列表' },
      { name: 'PushOrder', title: '推送订单' },
      { name: 'BatchOrder', title: '批量导单' },
      { name: 'CommodityList', title: '商品列表' }
    ])
  },
  mounted() {
    this.queryParams.merchantId = this.merchantId
    this.queryParams.platformId = this.platformId
  },
  methods: {
    //改单事件
    orderModificationEvent(record) {
      this.$router.push({
        name: 'ChangeOrder',
        query: {
          orderId: record.orderId,
          proId: record.proId,
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    },
    //退款事件
    refundEvent(record) {
      this.$router.push({
        name: 'RefundRequest',
        query: {
          orderId: record.orderId,
          proId: record.proId,
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    }
  }
}
</script>
<style scoped>
</style>
